export default __webpack_public_path__ + "static/media/expand-arrow.7ce0b7e1.svg";